export const heroData = [
  {
    id: "residential-solar",
    title: {
      number: "1",
      mainTitle: "Residential",

    },
    imageUrl: "/home/Housing.png",
  },

  {
    id: "housing-society-solar",
    title: {
      number: "2",
      mainTitle: "Housing Society",
    },
    imageUrl: "/home/Residential.png",
  },

  {
    id: "commercial-solar",
    title: {
      number: "3",
      mainTitle: "Commercial",

    },
    imageUrl: "/home/Commercial.png",
  },
];

